'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagPickerOptionGroup", {
    enumerable: true,
    get: function() {
        return TagPickerOptionGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagPickerOptionGroup = require("./useTagPickerOptionGroup");
const _renderTagPickerOptionGroup = require("./renderTagPickerOptionGroup");
const _useTagPickerOptionGroupStylesstyles = require("./useTagPickerOptionGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TagPickerOptionGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagPickerOptionGroup.useTagPickerOptionGroup)(props, ref);
    (0, _useTagPickerOptionGroupStylesstyles.useTagPickerOptionGroupStyles)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagPickerOptionGroupStyles_unstable')(state);
    return (0, _renderTagPickerOptionGroup.renderTagPickerOptionGroup)(state);
});
TagPickerOptionGroup.displayName = 'TagPickerOptionGroup';
